<template>
  <div class="global-msg-modal-container custom-z-index">
    <transition-group name="slide-up" tag="div" class="msg-list">
      <div
          v-for="(modal, index) in errorList"
          :key="modal.id"
          class="msg-modal"
          :style="{ top: `${-(errorList.length - 1 - index) * 8}px`, left: `${-(errorList.length - 1 - index) * 8}px` }"
      >
        <div class="msg-modal-content">
          <h3 v-if="modal.title" class="modal-title fs-20px fw-semi-bold text-center" :class="modal.class">{{ modal.title }}</h3>
          <p class="modal-message fs-16px">{{ modal.desc }}</p>
          <b-button class="w-100" variant="primary" @click="handleClose(modal)">確認</b-button>
        </div>
<!--        <button class="close-btn" @click="handleClose(modal)">-->
<!--          <icon name="close" size="24"></icon>-->
<!--        </button>-->
      </div>
    </transition-group>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  name: 'GlobalMsgModal',
  data() {
    return {
    };
  },
  components: {
  },
  props: {},
  beforeDestroy() {},
  async mounted() {},
  computed: {
    ...mapState('errorToast', {
      errorList: state => state.list
    }),
  },
  watch: {
  },
  methods: {
    ...mapActions('errorToast', ['close']),
    handleClose(modal) {
      this.close(modal.id);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/main";
.global-msg-modal-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 不擋下層點擊 */
}
.msg-list {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
}
.msg-modal {
  position: absolute;
  top: 0;
  left: 0;
  background: $color-white;
  width: 22rem;
  height: fit-content;
  border-radius: .75rem;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  transform: translate(-50%, -50%);
}

.msg-modal-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.modal-title {
  margin-bottom: 0;
}

.modal-message {
  color: $color-text-secondary;
  margin-bottom: 0;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  padding: .5rem;
}

/* === 動畫：從底下冒出／滑回下方消失 === */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all .5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-up-enter {
  opacity: 0;
  transform: translate(-50%, 50%);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translate(-50%, -50%);
}

.slide-up-leave {
  opacity: 1;
  transform: translate(-50%, -50%);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, 50%);
}
</style>
